import { OTPRequest, OTPResponse } from "domain/entity/OTP";
import OTPRepository from "domain/repository/OTP";
import { post } from "config/infra";

export default class OTPApi implements OTPRepository {
    async postOTP(body: OTPRequest): Promise<OTPResponse> {
        return post('/otp', body)
    }
}